import Repository from './Repository'
const URL_GET_MEDICINE = '/patients/medicines'

export default {
  getMedicines (payload) {
    return Repository.get(`${URL_GET_MEDICINE}`, payload)
  }
}
